// Refresh JWTs every 30 minutes
export const MAIN_JWT_REFRESH_DELAY = 30 * 60 * 4000;
export const SCOPED_JWT_REFRESH_DELAY = 30 * 60 * 4000;

export const SEARCH_PARAM_CREDENTIALS = 'credentials';
export const SEARCH_PARAM_OPTIONS = 'options';
export const SEARCH_PARAM_JWT_SCOPE = 'jwtScope';
